import { LatencyData } from 'core/models/latency';

function getTimestamp(view: DataView, offset: number) {
    const capture_msec =
        (view.getUint8(offset) << 8) + view.getUint8(offset + 1);
    const capture_epoch =
        (view.getUint8(offset + 2) << 24) +
        (view.getUint8(offset + 3) << 16) +
        (view.getUint8(offset + 4) << 8) +
        view.getUint8(offset + 5);

    return capture_epoch * 1000 + capture_msec;
}

function checkMagicNumber(view: DataView, offset: number) {
    if (
        view.getUint8(offset) == 0x85 &&
        view.getUint8(offset + 1) == 0xf4 &&
        view.getUint8(offset + 2) == 0xef &&
        view.getUint8(offset + 3) == 0x01
    ) {
        return true;
    }
    return false;
}

function getAdditionalData(view: DataView): [number, number, number, boolean] {
    if (view.byteLength > 23 &&
        view.getUint8(0) == 0x00 &&
        view.getUint8(1) == 0x00 &&
        view.getUint8(2) == 0x00 &&
        view.getUint8(3) == 0x01 &&
        view.getUint8(4) == 0x1f &&
        checkMagicNumber(view, 5)
    ) {
        // H.264
        const captureInMs = getTimestamp(view, 9);
        const janusTimeStamp = getTimestamp(view, 15);

        const isSyncFrame = view.getUint8(21) & 0x80 ? true : false;
        const encodedTime = view.getUint8(22);
        return [captureInMs, janusTimeStamp, encodedTime, isSyncFrame];
    } else if (
        view.byteLength > 28 &&
        view.getUint8(view.byteLength - 1) == 0xd9 &&
        view.getUint8(view.byteLength - 10) == 0xd9 &&
        checkMagicNumber(view, view.byteLength - 28)
    ) {
        // VP9
        const captureInMs = getTimestamp(view, view.byteLength - 24);
        const janusTimeStamp = getTimestamp(view, view.byteLength - 18);

        const isSyncFrame =
            view.getUint8(view.byteLength - 12) & 0x80 ? true : false;
        const encodedTime = view.getUint8(view.byteLength - 11);
        return [captureInMs, janusTimeStamp, encodedTime, isSyncFrame];
    } else if (view.byteLength > 17 &&
        checkMagicNumber(view, view.byteLength - 18)) {
        // VP8
        const captureInMs = getTimestamp(view, view.byteLength - 14);
        const janusTimeStamp = getTimestamp(view, view.byteLength - 8);

        const isSyncFrame =
            view.getUint8(view.byteLength - 2) & 0x80 ? true : false;
        const encodedTime = view.getUint8(view.byteLength - 1);
        return [captureInMs, janusTimeStamp, encodedTime, isSyncFrame];
    }
    return [0, 0, 0, false];
}

export class TimestampDecodingTransformer {
    private totalLatency = 0;
    private upstreamLatency = 0;
    private downstreamLatency = 0;
    private encodeTime = 0;


    async transform(
        chunk: { data: ArrayBufferLike },
        controller: TransformStreamDefaultController
    ) {
        const timestamp = Date.now();
        const view = new DataView(chunk.data);
        const [
            edgeTimestamp,
            janusTimestamp,
            encodeTime
        ] = getAdditionalData(view);

        if (edgeTimestamp > 0) {
            this.totalLatency = timestamp - edgeTimestamp;
        } else {
            this.totalLatency = 0;
        }

        if (janusTimestamp > 0) {
            if (edgeTimestamp < janusTimestamp) {
                this.upstreamLatency = janusTimestamp - edgeTimestamp;
            } else {
                this.upstreamLatency = 0;
            }
            if (timestamp > janusTimestamp) {
                this.downstreamLatency = timestamp - janusTimestamp;
            } else {
                this.downstreamLatency = 0;
            }
        } else {
            this.upstreamLatency = 0;
            this.downstreamLatency = 0;
        }
        this.encodeTime = encodeTime;
        controller.enqueue(chunk);
    }

    getLatency(): LatencyData {
        return { totalLatency: this.totalLatency, upstreamLatency: this.upstreamLatency, downstreamLatency: this.downstreamLatency, encodeTime: this.encodeTime };
    }
}
